import React from 'react';
import {css} from '@linaria/core';
import {styled} from '@linaria/react';
import {GridItem, LinksGrid} from './LinksGrid';
import {LinksGridContainer} from './LinksGridContainer';
import {mediaDesktopAndUp} from '../../../../constants/customMedia';
import {FONT_SIZES} from '../../../../constants/typography';

export interface LinkContainerProps {
  dataTestId: string;
  onLinkItemClick: () => void;
  sections: Array<{
    footer?: {label: string; url: {url: string}};
    headline?: string;
    items: GridItem[];
  }>;
  isSaleIndicationActive?: boolean;
}

export const LinkContainer: React.FC<LinkContainerProps> = ({
  dataTestId,
  onLinkItemClick,
  sections,
  isSaleIndicationActive,
}) => {
  const maxRowsPerLinkSectionInTabletView =
    {
      1: 3,
      2: 4,
    }[sections.length] ?? 6;

  return (
    <Wrapper data-testid={dataTestId}>
      {sections.map(({items, footer, headline}, index) => (
        <LinksGridContainer
          key={`linkContainer-${index}`}
          className={ItemClass}
          footer={footer}
          headline={headline}
          onLinkItemClick={onLinkItemClick}
        >
          <LinksGrid
            gridItems={items}
            onLinkItemClick={onLinkItemClick}
            maxRowsPerLinkSectionInTabletView={
              maxRowsPerLinkSectionInTabletView
            }
            isSaleIndicationActive={isSaleIndicationActive}
          />
        </LinksGridContainer>
      ))}
    </Wrapper>
  );
};

const ItemClass = css``;

const Wrapper = styled.div`
  display: flex;
  gap: 10px;
  font-size: ${FONT_SIZES.px12};

  .${ItemClass} {
    &:not(:last-child) {
      margin-right: 20px;

      @media ${mediaDesktopAndUp} {
        margin-right: 30px;
      }
    }
  }
`;
